import {Component, Host, h, Prop} from '@stencil/core';

@Component({
  tag: 'bam-stage-shared',
  styleUrl: 'bam-stage-shared.scss',
  shadow: false,
})
export class BamSharedStage {

  @Prop() color!: BalProps.BalStageColor
  @Prop() inverted: boolean | undefined
  @Prop() hasShape?: boolean
  @Prop() size?: 'small' | 'regular' = 'regular'

  render() {
    return (
      <Host
        class={{
          'bam-stage-shared': true,
          'bam-stage-shared--is-small': this.size === 'small',
        }}
      >
        <bal-stage
          size="large"
          container-size=""
          // inverted={this.inverted}
          color={this.color}
          class={{"has-shape": this.hasShape}}
        >
          <bal-stage-body class="py-none">
            <slot></slot>
          </bal-stage-body>
        </bal-stage>
      </Host>
    );
  }

}
